(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../utils/BlockFormControlLayout"), require("@square/maker-icons/ChevronDown"));
	else if(typeof define === 'function' && define.amd)
		define(["../../utils/BlockFormControlLayout", "@square/maker-icons/ChevronDown"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../utils/BlockFormControlLayout"), require("@square/maker-icons/ChevronDown")) : factory(root["../../utils/BlockFormControlLayout"], root["@square/maker-icons/ChevronDown"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 